import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-[var(--fx-r-pill)] px-2.5 py-0.5 text-xs font-semibold gap-1.5",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--fx-accent-100)] text-[var(--fx-accent-700)] dark:bg-[rgba(111,165,133,0.16)] dark:text-[var(--fx-accent-300)]",
        secondary:
          "bg-[var(--fx-ink-100)] text-[var(--fx-ink-700)] dark:bg-[rgba(244,239,230,0.08)] dark:text-[var(--dk-text-soft)]",
        destructive:
          "bg-[rgba(201,94,62,0.14)] text-[var(--fx-warn-text)] dark:bg-[rgba(201,94,62,0.18)] dark:text-[#E89978]",
        outline:
          "border border-[var(--fx-ink-200)] text-[var(--fx-ink-700)] bg-transparent dark:border-[var(--dk-border-2)] dark:text-[var(--dk-text)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    // data-slot gives this a stable hook the utility classes don't provide.
    // icon-motion.css uses it to keep hover motion off badge icons: a badge
    // describes state, so its icon is not an affordance even when the badge
    // happens to sit inside something hoverable.
    <div data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
